// src/components/Sections/FAQSection/faqContent.js
// Shared by the visible FAQ and structured data to avoid mismatched answers.

export const faqItems = [
  {
    question: 'What is The Tour Golfers?',
    answer: 'The Tour Golfers is an iOS-first digital country club for public golfers. It connects simple score tracking, your golf history, groups, Tour Series competition, and a growing member community in one membership.'
  },
  {
    question: 'Is this a membership to a specific golf course?',
    answer: 'No. Your membership is not tied to a single property, and you can continue playing the public courses you already enjoy. Course directory listings do not mean a course is an official partner.'
  },
  {
    question: 'How do Groups work?',
    answer: 'Create a group with your playing partners and start shared rounds when you play together. Each player records their own score within the outing, with handicap-adjusted results contributing to round rankings, season points, and group standings.'
  },
  {
    question: 'What is a Tour Series?',
    answer: 'A Tour Series is a multi-course competition designed to let members play participating stops on their own schedules. Scores contribute to a shared handicap-adjusted leaderboard; everyone does not have to play on the same day.'
  },
  {
    question: 'What does Founding Membership include?',
    answer: 'The planned annual membership connects practical scoring, GPS and Apple Watch support, golf history, Groups, Tour Series, leaderboards, and the member community. Event offerings and any separate entry fees will be communicated as they are confirmed.'
  },
  {
    question: 'Does membership include green fees or event tickets?',
    answer: 'No. Green fees, tournament entry fees, simulator bookings, ticketed events, travel, food and beverage, and selected premium experiences may carry separate charges. Planned partnerships are not included benefits until confirmed.'
  },
  {
    question: 'Is the $39.99 Founding Membership available to purchase now?',
    answer: 'The website currently accepts Founding Membership inquiries, not payment. The proposed founding rate is CAD $39.99 per year, retained while membership remains active; regular annual membership is planned at CAD $64.99.'
  },
  {
    question: 'What is available now, and what is planned for 2027?',
    answer: 'The app and core playing, group, competition, and community features have been built and are being refined. The founding community, recurring in-person experiences, and course partnerships are being developed for the 2027 GTA season; availability will be confirmed as plans are finalized.'
  },
  {
    question: 'What devices will The Tour Golfers support?',
    answer: 'The launch is iOS-first with Apple Watch support. No Android launch date is currently confirmed.'
  },
  {
    question: 'Where is the club launching?',
    answer: 'The initial community is being built in the Greater Toronto Area and Southern Ontario, with expansion considered after the founding community is established.'
  }
];
